<template>
<Teleport to="#modal-portal-target">
<div v-if="$store.getters['common/modalName'] === 'admingolfreservations'">
    <div class="modal-header">
        <h3 class="modal-title">
            {{ $_locale('tee times') }} - {{ $_formatDateTime($_dateFormat.DATETIME_DMY, date) }}
        </h3>
    </div>
    <div class="modal-body reservation-modal userteetime-modal">
        <div class="row">
            <div class="col-xs-12">
                <div class="pull-right" style="margin-bottom: 7px;">
                    <input type="text" v-model="search" class="form-control" :placeholder="$_locale('search')">
                </div>
            </div>
        </div>
        <div class="panel-body" style="padding: 0;">
            <wn-table-pages :items="golfReservations">
                <template #head>
                    <th style="min-width: 65px;"></th>
                    <th>{{ $_locale('tee time') }}</th>
                    <th>{{ $_locale('player') }}</th>
                    <th>{{ $_locale('order number') }}</th>
                    <th>{{ $_locale('created') }}</th>
                    <th>{{ $_locale('orderer') }}</th>
                </template>
                <template v-slot="{ item: row }">
                    <tr :key="row.reservationTimeId">
                    <td>
                        <div style="padding: 10px 0;display:flex;">
                            <button class="btn btn-xs btn-success" 
                                v-if="[2].indexOf(row.status) > -1"
                                @click="confirmTeeTime(row.reservationTimeId)">
                                <i class="glyphicon glyphicon-ok"></i>
                                <span>{{ $_locale('confirm') }}</span>
                            </button>
                            <button class="btn btn-xs btn-default" 
                                v-if="[3].indexOf(row.status) > -1"
                                @click="cancelConfirmedTeeTime(row.reservationTimeId)"
                                style="min-height: unset;">
                                <i class="glyphicon glyphicon-ok"></i>
                                <span>{{ $_locale('confirmed') }}</span>
                            </button>
                            <button class="btn btn-xs btn-danger" 
                                style="margin-left: 7px;"
                                v-if="[2,3].indexOf(row.status) > -1"
                                @click="deactivateReservationTime(row.reservationTimeId)">
                                <i class="glyphicon glyphicon-remove"></i>
                                <span>{{ $_locale('cancel') }}</span>
                            </button>
                        </div>
                    </td>
                    <td>
                        {{ $_formatDateTime($_dateFormat.DATETIME_HI, row.dateTimeStart) }}
                    </td>
                    <td>{{ row.firstName }} {{ row.familyName }}</td>
                    <td style="text-align:right;">
                        <a v-bind:href="orderLinkUrl(row.orderId)" target="_blank">
                            {{ row.orderId }}
                        </a>
                    </td>
                    <td>{{ $_formatDateTime($_dateFormat.DATETIME_DMYHI, row.dateCreated) }}</td>
                    <td>{{ row.reserverFirstName }} {{ row.reserverFamilyName }}</td>
                    </tr>
                </template>
            </wn-table-pages>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-default pull-left" 
            @click="$store.commit('common/setModal', null)">
            {{ $_locale('close') }}
        </button>
    </div>
</div>
</Teleport>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: () => ({
        search: ''
    }),
    computed: {
        ...mapGetters({
            adminMode: 'common/adminMode',
            orderLinkUrl: 'ecom/orderLinkUrl',
            reservations: 'reservations/reservations',
            reservationPlayers: 'golf/reservationPlayers',
            date: 'reservations/date',
        }),
        golfReservations() {
            const search = this.search.trim().toLowerCase();

            return this.reservations.filter(row => [2,3].indexOf(row.status) > -1)
            .sort((a, b) => {
                const a_start = moment(a.start);
                const b_start = moment(b.start);

                return a_start < b_start ? 1 : -1;
            }) 
            .map(row => {
                const player = this.reservationPlayers.filter(
                    player => player.reservationTimeId === row.reservationTimeId
                )[0] || {};

                return {
                    reservationTimeId: row.reservationTimeId,
                    orderId: row.orderId,
                    status: row.status,
                    dateCreated: row.dateCreated,
                    dateTimeStart: row.start,
                    reserverFirstName: row.firstName,
                    reserverFamilyName: row.lastName,
                    firstName: player.firstName,
                    familyName: player.familyName,
                    personId: player.personId,
                }
            })
            .filter(row => !!row.personId)
            .filter(row => {
                if (search.length === 0) return true;

                if (search.indexOf(row.orderId) > -1) return true;

                if (row.reserverFirstName.toLowerCase().indexOf(search) > -1) return true;
                if (row.reserverFamilyName.toLowerCase().indexOf(search) > -1) return true;

                if (row.firstName.toLowerCase().indexOf(search) > -1) return true;
                if (row.familyName.toLowerCase().indexOf(search) > -1) return true;

                return false;
            })
        }
    },
    watch: {
    },
    methods: {
        confirmTeeTime(reservationTimeId) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            this.$_swal({
                title: _locale('confirm tee time').ucfirst() + '?',
                text: '',
                type: 'success',
                showCancelButton: true,
                confirmButtonClass: 'btn-warning',
                confirmButtonText: _locale('confirm').ucfirst(),
                cancelButtonText: _locale('cancel').ucfirst()
            })
            .then((result) => {
                if (result.isConfirmed) {
                    EcomService.confirmTeeTime(reservationTimeId)
                        .then((response) => {
                            const data = response.data;

                            if (data.success) {
                                // dispatch datechange
                                this.$store.dispatch('reservations/onDateChange', this.date);
                            } else {
                                //showErrorDialog(data.message, true, false, true);
                            }
                        })
                }
            })
        },
        cancelConfirmedTeeTime(reservationTimeId) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            this.$_swal({
                title: `${ _locale('cancel').ucfirst() } ${ _locale('reservation confirmation') }?`,
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn-warning',
                confirmButtonText: _locale('yes').ucfirst(),
                cancelButtonText: _locale('close').ucfirst(),
            })
            .then((result) => {
                if (result.isConfirmed) {
                    EcomService.cancelConfirmedTeeTime(reservationTimeId)
                        .then((response) => {
                            const data = response.data;

                            if (data.success) {
                                // dispatch datechange
                                this.$store.dispatch('reservations/onDateChange', this.date);
                            } else {
                                //showErrorDialog(data.message, true, false, true);
                            }
                        })
                }
            })
        },
        deactivateReservationTime(reservationTimeId) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            
            this.$_swal({
                title: _locale('are you sure').ucfirst(),
                text: '',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn-warning',
                confirmButtonText: _locale('yes').ucfirst(),
                cancelButtonText: _locale('no').ucfirst()
            })
            .then((result) => {
                if (result.isConfirmed) {
                    EcomService.deactivateReservationTime(reservationTimeId)
                        .then((response) => {
                            const data = response.data;

                            if (data.success) {
                                // dispatch datechange
                                this.$store.dispatch('reservations/onDateChange', this.date);
                            } else {
                                //showErrorDialog(data.message, true, false, true);
                            }
                        })
                }
            })
        },
    },
    mounted() {
    }
}
</script>